module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [_c('Header'), _c('CertData', {
    attrs: {
      "childName": _vm.currentChild.childName,
      "certificateNumber": _vm.currentChild.certificateNumber,
      "certificateDateEnd": _vm.currentChild.certificateDateEnd,
      "isSertificateConfirmed": _vm.isSertificateConfirmed
    }
  }), _c('CertScore', {
    attrs: {
      "certificateType": _vm.currentChild.certificateType,
      "certificateAmountTotal": _vm.currentChild.certificateAmountTotal,
      "certificateAmountWithdraw": _vm.currentChild.certificateAmountWithdraw,
      "certificateAmountCurrent": _vm.currentChild.certificateAmountCurrent,
      "certificateAmountOnHold": _vm.currentChild.certificateAmountOnHold
    }
  }), (_vm.currentChild.isAccountType) ? _c('ExpiredCert', {
    attrs: {
      "to": _vm.currentChild.toIssue
    }
  }) : (!_vm.currentChild.childName || (_vm.currentChild.isNoType || _vm.currentChild.isUndefinedType)) ? _c('WithoutCert', {
    attrs: {
      "name": _vm.currentChild.childName,
      "needActivate": _vm.currentChild.isUndefinedType,
      "toConfirm": _vm.currentChild.toConfirm,
      "isApproved": _vm.currentChild.isApproved
    }
  }) : _vm._e(), (_vm.errors.length) ? _c('Errors', {
    attrs: {
      "errors": _vm.errors
    }
  }) : [(_vm.infoMessage.length) ? _c('Sucsess', {
    attrs: {
      "text": _vm.infoMessage,
      "btnText": _vm.sucsessBtnText
    },
    on: {
      "sucsess": _vm.sucsessHendler
    }
  }) : [(!_vm.isStatment) ? _c('Footer', {
    attrs: {
      "actionText": _vm.currentChild.actionText
    },
    on: {
      "action": function($event) {
        return _vm.action(_vm.currentChild.action)
      }
    }
  }) : (_vm.statementText.length) ? _c('Statement', {
    attrs: {
      "statement": _vm.statementText
    }
  }, [_c('StatementBtn', {
    on: {
      "btnClick": _vm.btnClickHendler
    }
  })], 1) : _vm._e()]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13db7e94","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/Certificate.vue
// module id = 6230d1ed67288024b68a
// module chunks = 9